import { createAsyncThunk } from "@reduxjs/toolkit";
import { InventoryAxios } from "api/InventoryAxios";
import { ProcurementAxios } from "api/ProcurementAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";


export const fetchWarehouseAllocation = createAsyncThunk(
  "warehouse/fetchWarehouseAllocation",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    type,
    wharehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    type?: string;
    wharehouse_id?: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              // Handle cases like { from_date: ..., to_date: ... }
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
                if (
                  (filterValue.from_date || filterValue.to_date) &&
                  (filterField === "created_at" || filterField === "updated_at")
                ) {
                  if (filterField === "created_at") {
                    filterField = "created";
                  } else {
                    filterField = "updated";
                  }
                  params.append("filter_by", filterField);
                }
              });
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }

    // const response: any = await WarehouseAxios
    //   .get(
    //     `/allocation/allocations/list/?type=${type}&${params.toString()}`
    //   );
    // // const response: any = await WarehouseAxios.get(
    // //   `/stock/issue-for-packing/list/?${params.toString()}`
    // // );

    // return {
    //   data: response?.data?.data || [],
    //   rowCount: response.data.count || 0,
    // };


    if (type === 'Allocation') {
      const response: any = await InventoryAxios.get(
        `/api/inventory_item_request/allocations/warehoue-allocations-listing/?wharehouse_id=${wharehouse_id}&${params.toString()}`
      );
      return {
        // data: response?.data?.results || [],
        data: response?.data?.data || [],
        rowCount: response.data.count || 0,
      };
    } else if (type === 'Items Request') {
      const response: any = await WarehouseAxios.get(
        `api/allocation/allocation-item-request-list/?wharehouse_id=${wharehouse_id}&${params.toString()}`
      );
      // console.log("response Item request: ", response);
      return {
        data: response?.data?.data || [],
        rowCount: response?.data.count || 0,
      };
    } else {
      return {
        data: [],
        rowCount: 0,
      };
    }
  }
);

export const exportPurchaseRequestCSV = async () => {
  const response = await ProcurementAxios.get("/purchase-request/list/?export=csv", {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};


export const fetchItemRequestViewDetailsById = createAsyncThunk(
  'warehouse/fetchItemRequestViewDetailsById',
  async (itemRequestLogId: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        `https://3jg09h9h-8006.inc1.devtunnels.ms/api/allocation/allocation-item-request-view-detail/${itemRequestLogId}/`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch item request view details');
    }
  }
);


